import { getLocations } from '@services/xhr-service';

export enum HotKeys {
  TAB = 'Tab',
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown'
}

export async function getLocationsList(location: string, size: number): Promise<IAutocompleteLocationProvider[]> {
  const payload: ILocationtypeaheadPayload = {
    prefix: location,
    size
  };
  const response = await getLocations(JSON.stringify(payload));

  if (response.ok) {
    const locations = await response.json();

    return locations.map(({ canonicalName }: IAutocompleteLocationProvider) => ({ canonicalName }));
  }

  return [];
}